import React, {Component} from 'react';
import { BrowserRouter } from 'react-router-dom'
import { connect } from "react-redux";
import Routes from '../routes';
import styled from 'styled-components';


class GameManager extends Component {
	render() {
		return(
			 <BrowserRouter>
			 	<div>
			 		{Routes}
			 	</div>
				
		 	 </BrowserRouter>
		)

	}

};

const mapStateToProps = ({ GameOptions }) => {
  return {
		unlockedLevel: GameOptions.unlocked_level
  };
};

export default connect(mapStateToProps)(GameManager);



// WEBPACK FOOTER //
// ./src/components/gamemanager.js